import React, { useState } from 'react';

function ConsentPage(){
    return(
    <div className="container mt-4">
      <h2><i className="bi bi-shield-check me-2"></i>Consent Management</h2>
      <div className="card mt-3">
        <div className="card-body">
          <div className="alert alert-info">
            <h5>Signed Documents</h5>
            <ul className="list-group">
              <li className="list-group-item d-flex justify-content-between">
                <span>Prenatal Care Consent</span>
                <span className="badge bg-success">Signed Nov 1, 2023</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsentPage;